export enum DynamicFormValidators {
  Required = 'required',
  Min = 'min',
  Max = 'max',
  Pattern = 'pattern',
  MaxLength = 'maxlength',
  MinLength = 'minlength',
}
